(() => {
  const svg = (body) => `<svg viewBox="0 0 48 48" aria-hidden="true" focusable="false">${body}</svg>`;
  const slash = '<path class="ageless-icon-slash" d="M12 36L36 12" />';

  const icons = {
    wheat: () => svg(`<path d="M24 9V39"/><path d="M24 15C20 12 17 12 15 13C16 17 19 19 24 20"/><path d="M24 21C28 18 31 18 33 19C32 23 29 25 24 26"/><path d="M24 27C20 24 17 24 15 25C16 29 19 31 24 32"/><path d="M24 14C28 11 31 11 33 12C32 16 29 18 24 19"/>${slash}`),
    leaf: () => svg(`<path d="M12 31C16 20 26 13 37 12C36 24 30 34 18 36C14 36 12 34 12 31Z"/><path d="M16 33C22 27 28 21 34 16"/>`),
    milk: () => svg(`<path d="M17 11H29L34 17V38H14V17L17 11Z"/><path d="M17 11L23 17H34"/><path d="M19 25C21 22 23 21 24 21C25 21 27 22 29 25C29 28 27 30 24 30C21 30 19 28 19 25Z"/>${slash}`),
    peanut: () => svg(`<path d="M18 13C14 15 13 20 16 24C13 27 13 32 16 35C19 38 23 38 26 35C29 38 34 37 37 33C40 29 39 24 35 22C38 18 36 13 32 11C28 9 24 11 22 15C21 13 19 12 18 13Z"/><path d="M19 19C23 21 27 22 32 22M17 28C22 27 27 29 31 33"/>${slash}`),
    molecule: () => svg(`<circle cx="16" cy="16" r="3.2"/><circle cx="32" cy="15" r="3.2"/><circle cx="24" cy="31" r="3.2"/><path d="M19 16L29 15M18 19L22 28M30 18L26 28"/>${slash}`),
    natural: () => svg(`<path d="M24 38V24"/><path d="M24 26C18 25 14 21 13 16C19 16 23 19 24 26Z"/><path d="M24 22C30 21 34 17 35 12C29 12 25 15 24 22Z"/><path d="M13 35H35"/><path d="M36 12V8M34 10H38"/>`),
    capsule: () => svg(`<path d="M15 31L29 17C32 14 36 14 39 17C42 20 42 24 39 27L25 41C22 44 18 44 15 41C12 38 12 34 15 31Z"/><path d="M22 24L32 34"/>${slash}`),
    dna: () => svg(`<path d="M17 10C31 16 31 32 17 38M31 10C17 16 17 32 31 38"/><path d="M19 15H29M16.5 22H31.5M16.5 29H31.5M19 36H29"/>${slash}`),
    corn: () => svg(`<path d="M24 11C31 14 34 20 33 28C32 36 28 40 24 40C20 40 16 36 15 28C14 20 17 14 24 11Z"/><path d="M19 17L29 34M29 17L19 34M16 24H32"/><path d="M15 31C10 30 8 27 8 23C13 24 16 27 17 31M33 31C38 30 40 27 40 23C35 24 32 27 31 31"/>${slash}`),
    vegan: () => svg(`<path d="M24 38V24"/><path d="M24 26C18 25 14 21 13 16C19 16 23 19 24 26Z"/><path d="M24 22C30 21 34 17 35 12C29 12 25 15 24 22Z"/><path d="M17 38H31"/>`),
    halal: () => svg(`<path d="M31 11C24 13 19 19 19 26C19 33 24 38 31 39C23 42 14 37 12 29C10 21 15 13 23 11C26 10 29 10 31 11Z"/><path d="M34 18L35.3 20.7L38.2 21.1L36.1 23.1L36.6 26L34 24.6L31.4 26L31.9 23.1L29.8 21.1L32.7 20.7Z"/>`),
    bunny: () => svg(`<path d="M18 21C14 16 14 9 17 7C21 8 23 14 23 20M30 21C34 16 34 9 31 7C27 8 25 14 25 20"/><path d="M14 29C14 23 18 20 24 20C30 20 34 23 34 29C34 35 30 39 24 39C18 39 14 35 14 29Z"/><circle class="ageless-icon-fill" cx="20" cy="29" r="1"/><circle class="ageless-icon-fill" cx="28" cy="29" r="1"/><path d="M22 34C23 35 25 35 26 34"/>`),
    bottle: () => svg(`<path d="M20 10H28V14L31 18V38H17V18L20 14V10Z"/><path d="M19 24H29"/>${slash}`),
    droplet: () => svg(`<path d="M24 9C24 9 14 21 14 29C14 35 18 39 24 39C30 39 34 35 34 29C34 21 24 9 24 9Z"/>${slash}`),
    fragrance: () => svg(`<circle cx="21" cy="24" r="4"/><path d="M21 20C18 16 18 13 21 11C24 13 24 16 21 20ZM17 23C13 20 10 20 9 23C11 26 14 27 17 25ZM25 23C29 20 32 20 33 23C31 26 28 27 25 25ZM19 28C17 32 18 35 21 36C24 34 24 31 22 28"/><path d="M35 17C37 18 39 18 40 17M35 22C37 23 39 23 40 22"/>${slash}`),
    egg: () => svg(`<path d="M24 9C18 9 13 20 13 28C13 35 18 39 24 39C30 39 35 35 35 28C35 20 30 9 24 9Z"/>${slash}`),
    fish: () => svg(`<path d="M11 25C16 18 25 16 34 22C36 20 39 19 41 19C40 22 40 28 41 31C38 31 36 30 34 28C25 34 16 32 11 25Z"/><circle class="ageless-icon-fill" cx="18" cy="24.5" r="1"/>${slash}`),
    soy: () => svg(`<path d="M13 29C18 18 27 13 36 13C35 22 30 31 20 35C16 36 13 33 13 29Z"/><circle cx="22" cy="26" r="2.2"/><circle cx="28" cy="22" r="2.2"/>${slash}`),
    sugar: () => svg(`<path d="M15 17L24 12L33 17V29L24 34L15 29V17Z"/><path d="M15 17L24 22L33 17M24 22V34"/>${slash}`),
    chemistry: () => svg(`<path d="M18 12H30M21 12V20L14 34C13 37 15 39 18 39H30C33 39 35 37 34 34L27 20V12"/><path d="M18 30H30"/>${slash}`),
    ring: () => svg(`<path d="M24 11L34 17V29L24 35L14 29V17L24 11Z"/><circle cx="24" cy="23" r="4"/>${slash}`),
    silicone: () => svg(`<ellipse cx="24" cy="24" rx="13" ry="6" transform="rotate(30 24 24)"/><ellipse cx="24" cy="24" rx="13" ry="6" transform="rotate(-30 24 24)"/><circle cx="24" cy="24" r="2.5"/>${slash}`),
    sulfate: () => svg(`<path d="M12 29C16 25 20 25 24 29C28 33 32 33 36 29"/><circle cx="17" cy="19" r="3"/><circle cx="27" cy="15" r="2"/><circle cx="34" cy="21" r="2.5"/>${slash}`),
    kosher: () => svg(`<path d="M24 10L29 19H39L34 27L39 36H29L24 44L19 36H9L14 27L9 19H19L24 10Z"/>`),
    shield: () => svg(`<path d="M24 9L36 14V24C36 32 31 38 24 41C17 38 12 32 12 24V14L24 9Z"/><path d="M18 25L22 29L30 20"/>`),
    noFillers: () => svg(`<path d="M18 11H30M21 11V19L14 34C13 37 15 39 18 39H30C33 39 35 37 34 34L27 19V11"/><path d="M18 30H30"/><circle cx="21" cy="25" r="1.3"/><circle cx="26" cy="27" r="1.3"/>${slash}`),
    tested: () => svg(`<path d="M18 10H30M21 10V19L14 34C13 37 15 39 18 39H30C33 39 35 37 34 34L27 19V10"/><path d="M18 30H29"/><circle cx="34" cy="16" r="7"/><path d="M30.5 16L33 18.5L37.5 13.5"/>`),
    gmp: () => svg(`<path d="M10 39V23L18 18V23L26 18V39H10Z"/><path d="M26 25H37V39H26"/><path d="M14 29H18M14 34H18M30 31H34"/><circle cx="35" cy="15" r="7"/><path d="M31.5 15L34 17.5L38.5 12.5"/>`)
  };

  const subheadingLabels = new Set([
    'ingredient', 'ingredients', 'suggested use', 'caffeine', 'storage and caution',
    'product attributes', 'warning', 'warnings', 'directions', 'how to use'
  ]);

  function decorateSubheadings() {
    document.querySelectorAll('h2, h3, h4').forEach((heading) => {
      if (subheadingLabels.has(heading.textContent.trim().toLowerCase())) {
        heading.classList.add('ageless-product-subheading');
      }
    });
  }

  function iconFor(label) {
    const key = label.toLowerCase();
    if (key.includes('artificial filler')) return icons.noFillers();
    if (key.includes('third-party tested') || key.includes('third party tested')) return icons.tested();
    if (key.includes('gmp-certified') || key.includes('gmp certified')) return icons.gmp();
    if (key.includes('gluten')) return icons.wheat();
    if (key.includes('vegetarian')) return icons.leaf();
    if (key.includes('lactose') || key.includes('dairy')) return icons.milk();
    if (key.includes('allergen')) return icons.peanut();
    if (key.includes('hormone')) return icons.molecule();
    if (key.includes('natural') || key.includes('organic')) return icons.natural();
    if (key.includes('antibiotic')) return icons.capsule();
    if (key.includes('non-gmo') || key.includes('gmo')) return icons.dna();
    if (key.includes('corn')) return icons.corn();
    if (key.includes('vegan')) return icons.vegan();
    if (key.includes('halal')) return icons.halal();
    if (key.includes('cruelty')) return icons.bunny();
    if (key.includes('alcohol')) return icons.bottle();
    if (key.includes('mineral oil')) return icons.droplet();
    if (key.includes('fragrance')) return icons.fragrance();
    if (key.includes('paraben')) return icons.chemistry();
    if (key.includes('phthalate')) return icons.ring();
    if (key.includes('silicone')) return icons.silicone();
    if (key.includes('sulfate')) return icons.sulfate();
    if (key.includes('egg')) return icons.egg();
    if (key.includes('fish') || key.includes('shellfish')) return icons.fish();
    if (key.includes('soy')) return icons.soy();
    if (key.includes('sugar')) return icons.sugar();
    if (key.includes('kosher')) return icons.kosher();
    return icons.shield();
  }

  function displayLabel(label) {
    const key = label.toLowerCase();
    if (key.includes('gmp-certified') || key.includes('gmp certified')) return 'GMP-certified USA facility';
    return label;
  }

  function parseAttributes(text) {
    return text
      .replace(/✓/g, '')
      .split(/[·•]/)
      .map((item) => item.trim().replace(/^[-–—]+|[-–—]+$/g, '').trim())
      .filter(Boolean);
  }

  function makeAttributeGrid(attributes, extraClass = '') {
    const grid = document.createElement('div');
    grid.className = `ageless-attribute-icons${extraClass ? ` ${extraClass}` : ''}`;
    grid.setAttribute('role', 'list');

    attributes.forEach((label) => {
      const item = document.createElement('div');
      item.className = 'ageless-attribute-icon-item';
      item.setAttribute('role', 'listitem');

      const circle = document.createElement('div');
      circle.className = 'ageless-attribute-icon-circle';
      circle.innerHTML = iconFor(label);

      const text = document.createElement('div');
      text.className = 'ageless-attribute-icon-label';
      text.textContent = displayLabel(label);

      item.append(circle, text);
      grid.appendChild(item);
    });

    return grid;
  }

  function renderInlineAttributeClaims() {
    document.querySelectorAll('main p > strong').forEach((strong) => {
      const source = strong.parentElement;
      if (!source || source.children.length !== 1) return;

      const claim = strong.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      const hasTested = claim.includes('third-party tested') || claim.includes('third party tested');
      const hasGmp = claim.includes('gmp-certified') || claim.includes('gmp certified');
      const hasVegan = claim.includes('vegan capsules');
      const hasFillers = claim.includes('artificial fillers');

      if (!(hasTested && hasGmp && hasVegan && hasFillers)) return;

      const attributes = [
        'Third-party tested',
        'GMP-certified USA facility',
        'Vegan capsules',
        'No artificial fillers'
      ];

      const wrapper = document.createElement('div');
      wrapper.className = 'ageless-attribute-claims';

      const grid = makeAttributeGrid(attributes, 'ageless-attribute-icons--bundle');
      grid.setAttribute('aria-label', 'Product attributes');
      grid.style.gridTemplateColumns = 'repeat(4, minmax(0, 1fr))';
      grid.style.maxWidth = '340px';
      grid.style.marginTop = '18px';
      grid.style.marginBottom = '8px';

      const note = document.createElement('p');
      note.className = 'ageless-attribute-claims__note';
      note.style.margin = '0 0 18px';
      note.style.maxWidth = '340px';
      note.style.fontSize = '0.78rem';
      note.style.lineHeight = '1.45';
      note.style.color = '#52645A';
      note.append(document.createTextNode('Manufactured in the USA from globally sourced ingredients. Batch tested by an accredited third-party laboratory — certificate of analysis available on request at '));
      const mail = document.createElement('a');
      mail.href = 'mailto:support@ageless-labs.com';
      mail.textContent = 'support@ageless-labs.com';
      mail.style.color = '#2C6137';
      mail.style.fontWeight = '600';
      note.append(mail, document.createTextNode('.'));

      wrapper.append(grid, note);
      source.replaceWith(wrapper);
    });
  }

  function renderAttributes() {
    decorateSubheadings();

    document.querySelectorAll('h2, h3').forEach((heading) => {
      if (heading.textContent.trim().toLowerCase() !== 'product attributes') return;
      if (heading.dataset.agelessAttributesDone === 'true') return;

      const source = heading.nextElementSibling;
      if (!source) return;

      const attributes = parseAttributes(source.textContent || '');
      if (!attributes.length) return;

      const grid = makeAttributeGrid(attributes);
      source.replaceWith(grid);
      heading.dataset.agelessAttributesDone = 'true';
    });

    renderInlineAttributeClaims();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderAttributes, { once: true });
  } else {
    renderAttributes();
  }

  document.addEventListener('shopify:section:load', renderAttributes);
})();
